export enum SortEnum {
    Trending = 0,
    PriceAsc = 1,
    PriceDesc = 2,
    MostReviewed = 3,
    NameAsc = 4,
    NameDesc = 5
}